export enum MarketingDesignExportFormat {
  JPG = 'jpg',
  PNG = 'png',
  PDF = 'pdf',
  MP4 = 'mp4',
}

export const marketingDesignExportFormatLabels: Record<MarketingDesignExportFormat, string> = {
  [MarketingDesignExportFormat.JPG]: 'JPG',
  [MarketingDesignExportFormat.PNG]: 'PNG',
  [MarketingDesignExportFormat.PDF]: 'PDF',
  [MarketingDesignExportFormat.MP4]: 'MP4',
};
